import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const nongtungjaiApi = {
  getPatientList: (request) => {
    const { config } = request
    return instance().get('/nong-tung-jai/member-list', config)
  },
  getPatientDetails: (request, member_id) => {
    const { config } = request
    return instance().get(`/nong-tung-jai/subretroact-list/${member_id}`, config)
  },
  getCurrentRetroactWithSubretroact: (request, member_id) => {
    const { config } = request
    return instance().get(`/nong-tung-jai/current-retroact-with-subretroact/${member_id}`, config)
  },
  getSummary3Months: (request, member_id) => {
    const { config } = request
    return instance().get(`/nong-tung-jai/analyze-3-months/${member_id}`, config)
  }
}
export default nongtungjaiApi



// WEBPACK FOOTER //
// ./src/api/nongtungjai.js